import { useEffect, useState } from "react";
import { getInvoices } from "../api/invoiceapi";

function Reports() {

  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await getInvoices();
    setInvoices(res.data);
  };

  return (

    <div className="report-card">

      <h2 className="report-heading">INVOICE REPORTS</h2>

      <table className="report-table">

        <thead>
          <tr>
            <th>Invoice Id</th>
            <th>Customer</th>
            <th>Total</th>
            <th>GST</th>
            <th>Received</th>
            <th>Balance</th>
            <th>Status</th>
       
          </tr>
        </thead>

        <tbody>

          {invoices.map((invoice,index) => (

            <tr key={invoice.id}>

               <td>{index + 1}</td>

              <td>{invoice.customer}</td>

              <td>₹{invoice.grandTotal}</td>

              <td>₹{invoice.gst}</td>

              <td>₹{invoice.receivedAmount}</td>

              <td>
                ₹
                {invoice.grandTotal -
                  invoice.receivedAmount}
              </td>

              <td>
                {
                  invoice.receivedAmount >=
                  invoice.grandTotal
                    ? "Paid"
                    : "Pending"
                }
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}

export default Reports;